/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import ViewUser from "../views/Users/ViewUser.vue";
import UserPermission from "../views/Users/UserPermission.vue";
``;

// Container
const TheContainer = () =>
  import(
    /* webpackChunkName: "thecontainer" */ "../Container/TheContainer.vue"
  );

// Dashboard
const Dashboard = () =>
  import(/* webpackChunkName: "Dashboard" */ "../views/Dashboard.vue");

// View --Pages
const ForgotPassword = () =>
  import(
    /* webpackChunkName: "ForgotPassword" */ "../views/Pages/ForgotPassword.vue"
  );
const ResetPassword = () =>
  import(
    /* webpackChunkName: "ResetPassword" */ "../views/Pages/ResetPassword.vue"
  );
const CreatePassword = () =>
  import(
    /* webpackChunkName: "CreatePassword" */ "../views/Pages/CreatePassword.vue"
  );
const VerifyMail = () =>
  import(/* webpackChunkName: "VerifyMail" */ "../views/Pages/VerifyMail.vue");
const Login = () =>
  import(/* webpackChunkName: "Login" */ "../views/Pages/Login.vue");
const Signup = () =>
  import(/* webpackChunkName: "Signup" */ "../views/Pages/Signup.vue");
const NotFound = () =>
  import(/* webpackChunkName: "NotFound" */ "../views/Pages/NotFound.vue");

// View --Subscriptions
// const Subscriptions = () =>
//   import(
//     /* webpackChunkName: "Subscriptions" */ "../views/Subscriptions/Subscriptions.vue"
//   );
// const AddSubscription = () =>
//   import(
//     /* webpackChunkName: "AddSubscription" */ "../views/Subscriptions/AddSubscription.vue"
//   );
// const ViewSubscription = () =>
//   import(
//     /* webpackChunkName: "ViewSubscription" */ "../views/Subscriptions/ViewSubscription.vue"
//   );

// View --Profile
const ChangePassword = () =>
  import(
    /* webpackChunkName: "ChangePassword" */ "../views/Profile/ChangePassword.vue"
  );
const EditProfile = () =>
  import(
    /* webpackChunkName: "EditProfile" */ "../views/Profile/EditProfile.vue"
  );

// View --AuditTrail
const AuditTrail = () =>
  import(
    /* webpackChunkName: "AuditTrail" */ "../views/AuditTrail/AuditTrail.vue"
  );

// View --Users
const Users = () =>
  import(/* webpackChunkName: "Users" */ "../views/Users/Users.vue");

// View --Developers
const Developers = () =>
  import(
    /* webpackChunkName: "Developers" */ "../views/Developers/Developers.vue"
  );

// View --BusinessProfile
const BusinessProfile = () =>
  import(
    /* webpackChunkName: "BusinessProfile" */ "../views/BusinessProfile/BusinessProfile.vue"
  );
const OneTimeProfile = () =>
  import(
    /* webpackChunkName: "OneTimeProfile" */ "../views/BusinessProfile/OneTimeProfile.vue"
  );

// View --Devices
const Devices = () =>
  import(/* webpackChunkName: "Devices" */ "../views/Devices/Devices.vue");
const ViewDevice = () =>
  import(/* webpackChunkName: "Devices" */ "../views/Devices/ViewDevice.vue");
const SetupDevice = () =>
  import(
    /* webpackChunkName: "SetupDevice" */ "../views/Devices/SetupDevice.vue"
  );
const DeviceDetails = () =>
  import(
    /* webpackChunkName: "DeviceDetails" */ "../views/Devices/DeviceDetails.vue"
  );
// const DeviceNotifications = () =>
//   import(
//     /* webpackChunkName: "DeviceNotifications" */ "../views/Devices/DeviceNotifications.vue"
//   );
const DeviceExcursions = () =>
  import(
    /* webpackChunkName: "DeviceExcursions" */ "../views/Devices/DeviceExcursion.vue"
  );
const DeviceReport = () =>
  import(
    /* webpackChunkName: "DeviceReport" */ "../views/Devices/DeviceReport.vue"
  );
const DeviceSettings = () =>
  import(
    /* webpackChunkName: "DeviceSettings" */ "../views/Devices/DeviceSettings.vue"
  );
const DecommissionedDevices = () =>
  import(
    /* webpackChunkName: "DecommissionedDevices" */ "../views/Devices/DecommissionedDevices.vue"
  );

// View --LiveMap
const Maps = () =>
  import(/* webpackChunkName: "Maps" */ "../views/Maps/Maps.vue");

// View --Groups
const Groups = () =>
  import(/* webpackChunkName: "Groups" */ "../views/Groups/Groups.vue");
const ViewGroup = () =>
  import(/* webpackChunkName: "ViewGroup" */ "../views/Groups/ViewGroup.vue");
const GroupDevices = () =>
  import(
    /* webpackChunkName: "GroupDevices" */ "../views/Groups/GroupDevices.vue"
  );
const GroupUsers = () =>
  import(/* webpackChunkName: "GroupUsers" */ "../views/Groups/GroupUsers.vue");
const GroupSettings = () =>
  import(
    /* webpackChunkName: "GroupSettings" */ "../views/Groups/GroupSettings.vue"
  );
const GroupOverview = () =>
  import(
    /* webpackChunkName: "GroupOverview" */ "../views/Groups/GroupOverview.vue"
  );
const GroupChart = () =>
  import(
    /* webpackChunkName: "GroupOverview" */ "../views/Groups/GroupChart.vue"
  );
const GroupRecords = () =>
  import(
    /* webpackChunkName: "GroupRecords" */ "../views/Groups/GroupRecords.vue"
  );
const ViewGroupRecord = () =>
  import(
    /* webpackChunkName: "ViewGroupRecord" */ "../views/Groups/ViewGroupRecord.vue"
  );

// View --Records
const Records = () =>
  import(/* webpackChunkName: "Records" */ "../views/Records/Records.vue");
const ViewRecord = () =>
  import(
    /* webpackChunkName: "ViewRecord" */ "../views/Records/ViewRecord.vue"
  );
// View --Alarms
const AlarmTabs = () =>
  import(/* webpackChunkName: "Alarms" */ "../views/Alarm/AlarmTabs.vue");
const Alarms = () =>
  import(/* webpackChunkName: "Alarms" */ "../views/Alarm/Alarm.vue");
const TriggeredAlarms = () =>
  import(/* webpackChunkName: "Alarms" */ "../views/Alarm/TriggeredAlarms.vue");

const ViewAlarm = () =>
  import(/* webpackChunkName: "ViewAlarm" */ "../views/Alarm/ViewAlarm.vue");
const AlarmDetails = () =>
  import(
    /* webpackChunkName: "AlarmDetails" */ "../views/Alarm/AlarmDetails.vue"
  );

const AlarmSettings = () =>
  import(
    /* webpackChunkName: "AlarmSettings" */ "../views/Alarm/AlarmSettings.vue"
  );

const AddAlarmPage = () =>
  import(
    /* webpackChunkName: "AlarmSettings" */ "../views/Alarm/AddAlarmPage.vue"
  );

// const ViewRecord = () =>
//   import(
//     /* webpackChunkName: "ViewRecord" */ '../views/Records/ViewRecord.vue'
//   );

// View --Wallet
const Wallet = () =>
  import(/* webpackChunkName: "Wallet" */ "../views/Wallet/Wallet.vue");

const WalletDetails = () =>
  import(
    /* webpackChunkName: "WalletDetails" */ "../views/Wallet/WalletDetails.vue"
  );
const WalletHistory = () =>
  import(
    /* webpackChunkName: "WalletHistory" */ "../views/Wallet/WalletHistory.vue"
  );
const WalletSettings = () =>
  import(
    /* webpackChunkName: "WalletSettings" */ "../views/Wallet/WalletSettings.vue"
  );

// View --Wallet
const Subscription = () =>
  import(
    /* webpackChunkName: "Subscription" */ "../views/Wallet/Subscription/Subscription.vue"
  );

const SubDevices = () =>
  import(
    /* webpackChunkName: "WalletDetails" */ "../views/Wallet/Subscription/SubDevices.vue"
  );
const SubLicence = () =>
  import(
    /* webpackChunkName: "WalletHistory" */ "../views/Wallet/Subscription/SubLicenses.vue"
  );
const SubInvoice = () =>
  import(
    /* webpackChunkName: "WalletSettings" */ "../views/Wallet/Subscription/SubInvoices.vue"
  );

// View --Reports
// const Reports = () =>
//   import(/* webpackChunkName: "Reports" */ "../views/Reports/ReportError.vue");
const Reports = () =>
  import(/* webpackChunkName: "Reports" */ "../views/Reports/Reports.vue");

// View --Settings
const Settings = () =>
  import(/* webpackChunkName: "Settings" */ "../views/Settings/Settings.vue");

// View --Support
const Support = () =>
  import(/* webpackChunkName: "Support" */ "../views/Support/Support.vue");
// View --Dispatch
const Dispatch = () =>
  import(/* webpackChunkName: "Dispatch" */ "../views/Dispatch/Dispatch.vue");

const DispatchOverview = () =>
  import(
    /* webpackChunkName: "DispatchOverview" */ "../views/Dispatch/DispatchOverview.vue"
  );

const DispatchOrder = () =>
  import(
    /* webpackChunkName: "DispatchOrder */ "../views/Dispatch/DispatchOrder.vue"
  );

const DispatchContacts = () =>
  import(
    /* webpackChunkName: "DispatchContacts" */ "../views/Dispatch/DispatchContacts.vue"
  );

const DispatchDrivers = () =>
  import(
    /* webpackChunkName: "DispatchDrivers" */ "../views/Dispatch/DispatchDrivers.vue"
  );

const DriverDetails = () =>
  import(
    /* webpackChunkName: "DriverDetails" */ "../views/Dispatch/DriverDetails.vue"
  );

const DispatchVehicles = () =>
  import(
    /* webpackChunkName: "DispatchVehicles" */ "../views/Dispatch/DispatchVehicles.vue"
  );

const AddDispatch = () =>
  import(
    /* webpackChunkName: "AddDispatch" */ "../views/Dispatch/AddDispatch/AddDispatch.vue"
  );

const ExportDispatch = () =>
  import(
    /* webpackChunkName: "ExportDispatch" */ "../views/Dispatch/ExportDispatch/ExportDispatch.vue"
  );

const ExportDispatchOverview = () =>
  import(
    /* webpackChunkName: "ExportDispatchOverview" */ "../views/Dispatch/ExportDispatch/ExportDispatchOverview.vue"
  );

const ExportDispatchOrigin = () =>
  import(
    /* webpackChunkName: "ExportDispatchOrigin" */ "../views/Dispatch/ExportDispatch/ExportDispatchOrigin.vue"
  );

const ExportDispatchDestination = () =>
  import(
    /* webpackChunkName: "ExportDispatchDestination" */ "../views/Dispatch/ExportDispatch/ExportDispatchDestination.vue"
  );

const ExportDispatchAddShipment = () =>
  import(
    /* webpackChunkName: "ExportDispatchAddShipment" */ "../views/Dispatch/AddShipment/AddShipment.vue"
  );

const DispatchPartners = () =>
  import(
    /* webpackChunkName: "DispatchPartners" */ "../views/Dispatch/DispatchPartners.vue"
  );

const DeviceSession = () =>
  import(
    /* webpackChunkName: "DeviceSession" */ "../views/Devices/DeviceSession.vue"
  );
const DeviceSessions = () =>
  import(
    /* webpackChunkName: "DeviceSessions" */ "../views/Devices/Sessions.vue"
  );

const DeviceSessionHistory = () =>
  import(
    /* webpackChunkName: "DeviceSessionHistory" */ "../views/Devices/DeviceSessionHistory.vue"
  );

const ChartSettings = () =>
  import("./../views/ChartSettings/ChartSettings.vue");
Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/signup",
  //   name: "Signup",
  //   component: Signup,
  //   meta: {
  //     requiresGuest: true,
  //   },
  // },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: "/reset/:token",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      requiresGuest: true,
    },
  },
  {
    path: "/usersetup/:token",
    name: "CreatePassword",
    component: CreatePassword,
  },
  {
    path: "/verify/:token",
    name: "VerifyMail",
    component: VerifyMail,
  },

  {
    path: "/",
    redirect: "/dashboard",
    name: "TheContainer",
    component: TheContainer,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
      // {
      //   path: "/subscriptions",
      //   name: "Subscriptions",
      //   component: Subscriptions,
      // },
      // {
      //   path: "/subscriptions/addsubscription",
      //   name: "AddSubscription",
      //   component: AddSubscription,
      // },
      // {
      //   path: "/subscriptions/:key",
      //   name: "ViewSubscription",
      //   component: ViewSubscription,
      // },

      {
        path: "/maps",
        name: "Maps",
        component: Maps,
      },

      {
        path: "/logs",
        name: "AuditTrail",
        component: AuditTrail,
      },
      // {
      //   path: "/users",
      //   name: "Users",
      //   component: Users,
      // },
      {
        path: "/users",
        redirect: "/users/all-users",
        name: "ViewUsers",
        component: ViewUser,
        children: [
          {
            path: "/users/all-users",
            name: "Users",
            component: Users,
          },
          {
            path: "/users/permissions",
            name: "UserPermission",
            component: UserPermission,
            meta: {
              requiresViewPermission: true,
            },
          },
        ],
      },
      {
        path: "/groups",
        name: "Groups",
        component: Groups,
        // meta: {
        //   requiresViewPermission: true,
        // },
      },
      {
        path: "/dispatch",
        name: "Dispatch",
        redirect: "/dispatch/overview",
        component: Dispatch,
        children: [
          {
            path: "/dispatch/overview",
            name: "DispatchOverview",
            component: DispatchOverview,
          },
          {
            path: "/dispatch/contacts",
            name: "DispatchContacts",
            component: DispatchContacts,
          },
          {
            path: "/dispatch/drivers",
            name: "DispatchDrivers",
            component: DispatchDrivers,
          },
          {
            path: "/dispatch/vehicles",
            name: "DispatchVehicles",
            component: DispatchVehicles,
          },
          {
            path: "/dispatch/partners",
            name: "DispatchPartners",
            component: DispatchPartners,
          },
        ],
      },
      {
        path: "/dispatch/drivers/:id",
        name: "DriverDetails",
        component: DriverDetails,
        props: true,
      },
      {
        path: "/dispatch/add-dispatch",
        name: "AddDispatch",
        component: AddDispatch,
      },
      {
        path: "/dispatch/order/:id",
        name: "DispatchOrder",
        component: DispatchOrder,
      },
      {
        path: "/export",
        name: "ExportDispatch",
        component: ExportDispatch,
        redirect: "/export/dispatch",
        children: [
          {
            path: "/export/dispatch",
            name: "ExportDispatchOverview",
            component: ExportDispatchOverview,
          },
          {
            path: "/export/dispatch/origin",
            name: "ExportDispatchOrigin",
            component: ExportDispatchOrigin,
          },
          {
            path: "/export/dispatch/destination",
            name: "ExportDispatchDestination",
            component: ExportDispatchDestination,
          },
          {
            path: "/export/dispatch/partners",
            name: "ExportDispatchPartners",
            component: DispatchPartners,
          },
        ],
      },
      {
        path: "/export/dispatch/add-shipment",
        name: "ExportDispatchAddShipment",
        component: ExportDispatchAddShipment,
      },
      {
        path: "/groups/:id",
        redirect: "/groups/:id/overview",
        name: "ViewGroup",
        component: ViewGroup,
        meta: {
          requiresViewPermission: true,
        },
        children: [
          {
            path: "/groups/:id/overview",
            name: "GroupOverview",
            component: GroupOverview,
          },
          {
            path: "/groups/:id/group-chart",
            name: "GroupChart",
            component: GroupChart,
          },
          {
            path: "/groups/:id/devices",
            name: "GroupDevices",
            component: GroupDevices,
          },
          {
            path: "/groups/:id/users",
            name: "GroupUsers",
            component: GroupUsers,
          },
          {
            path: "/groups/:id/settings",
            name: "GroupSettings",
            component: GroupSettings,
            meta: {
              requiresEditPermission: true,
            },
          },
          {
            path: "/groups/:id/records",
            name: "GroupRecords",
            component: GroupRecords,
          },
          {
            path: "/groups/:id/records/:record_id",
            name: "ViewGroupRecord",
            component: ViewGroupRecord,
          },
        ],
      },
      {
        path: "/settings",
        redirect: "/settings/profile",
        name: "Settings",
        component: Settings,
        children: [
          {
            path: "/settings/profile",
            name: "EditProfile",
            component: EditProfile,
          },
          {
            path: "/settings/businessprofile",
            name: "BusinessProfile",
            component: BusinessProfile,
          },

          {
            path: "/settings/changepassword",
            name: "ChangePassword",
            component: ChangePassword,
          },
          {
            path: "/settings/chart-settings",
            name: "ChartSettings",
            component: ChartSettings,
          },
          {
            path: "/settings/decommissioned-devices",
            name: "DecommissionedDevices",
            component: DecommissionedDevices,
          },
          // {
          //   path: "/settings/developers",
          //   name: "Developers",
          //   component: Developers,
          // },
        ],
      },

      {
        path: "/companyprofile",
        name: "OneTimeProfile",
        component: OneTimeProfile,
      },
      {
        path: "/devices",
        name: "DeviceSession",
        component: DeviceSession,
        redirect: "/devices/device-overview",
        children: [
          {
            path: "/devices/device-overview",
            name: "DeviceSessionOverview",
            component: Devices,
          },
          {
            path: "/devices/device-sessions",
            name: "DeviceSessions",
            component: DeviceSessions,
          },
          {
            path: "/devices/device-session/:id/history",
            name: "DeviceSessionHistory",
            component: DeviceSessionHistory,
          },
        ],
      },
      {
        path: "/devices/setupdevice/:device_id",
        name: "SetupDevice",
        component: SetupDevice,
        meta: {
          requiresViewPermission: true,
        },
      },
      {
        path: "/devices/:device_id",
        redirect: "/devices/:device_id/details",
        name: "ViewDevice",
        component: ViewDevice,
        meta: {
          requiresViewPermission: true,
        },
        children: [
          {
            path: "/devices/:device_id/details",
            name: "DeviceDetails",
            component: DeviceDetails,
          },
          {
            path: "/devices/:device_id/excursions",
            name: "DeviceExcursions",
            component: DeviceExcursions,
          },
          {
            path: "/devices/:device_id/settings",
            name: "DeviceSettings",
            component: DeviceSettings,
          },
        ],
      },

      {
        path: "/devices/report/:device_id",
        name: "DeviceReport",
        component: DeviceReport,
        meta: {
          requiresViewPermission: true,
        },
      },

      {
        path: "/records",
        name: "Records",
        component: Records,
      },
      {
        path: "/records/:id",
        name: "ViewRecord",
        component: ViewRecord,
      },
      {
        path: "/alarms",
        name: "AlarmsHome",
        component: AlarmTabs,
        redirect: "/alarms/list",
        children: [
          {
            path: "/alarms/list",
            name: "Alarms",
            component: Alarms,
          },
          {
            path: "/alarms/triggered-alarms",
            name: "TriggeredAlarms",
            component: TriggeredAlarms,
          },
        ],
      },
      {
        path: "/alarms/add-alarm-page",
        name: "AddAlarmPage",
        component: AddAlarmPage,
      },
      {
        path: "/alarms/:alarm_id",
        name: "ViewAlarm",
        redirect: "/alarms/:alarm_id/details",
        component: ViewAlarm,
        meta: {
          requiresViewPermission: true,
        },
        children: [
          {
            path: "/alarms/:alarmId/details",
            name: "AlarmDetails",
            component: AlarmDetails,
          },
          {
            path: "/alarms/:alarmId/settings",
            name: "AlarmSettings",
            component: AlarmSettings,
            meta: {
              requiresEditPermission: true,
            },
          },
        ],
      },
      {
        path: "/wallet",
        name: "Wallet",
        redirect: "/wallet/overview",
        component: Wallet,
        children: [
          {
            path: "/wallet/overview",
            name: "WalletDetails",
            component: WalletDetails,
          },
          // {
          //   path: "/wallet/history",
          //   name: "WalletHistory",
          //   component: WalletHistory,
          // },
          {
            path: "/wallet/settings",
            name: "WalletSettings",
            component: WalletSettings,
          },
        ],
      },
      {
        path: "/subscription",
        name: "Subscription",
        redirect: "/subscription/devices",
        component: Subscription,
        children: [
          {
            path: "/subscription/devices",
            name: "SubscriptionDevices",
            component: SubDevices,
          },
          {
            path: "/subscription/licences",
            name: "SubscriptionLicences",
            component: SubLicence,
          },
          {
            path: "/subscription/invoices",
            name: "SubscriptionInvoices",
            component: SubInvoice,
          },
        ],
      },
      {
        path: "/reports",
        name: "Reports",
        component: Reports,
      },
      {
        path: "/support",
        name: "Support",
        component: Support,
      },
      // {
      //   path: '/records/:id',
      //   name: 'ViewRecord',
      //   component: ViewRecord,
      // },
      // {
      //   path: "/devices/settings/:device_id",
      //   name: "DeviceSettings",
      //   component: DeviceSettings,
      // }
    ],
  },
  {
    path: "/404",
    name: "NotFound",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const token = localStorage.getItem("token");
if (!token) {
  store.dispatch("logout");
}

const moduleRouteMapping = {
  devices: "/devices",
  groups: "/groups",
  alarms: "/alarms",
  reports: "/reports",
  users: "/users",
  dispatch: "/dispatch",
  payments: "/payments",
};

router.beforeEach((to, from, next) => {
  const { isLoggedOn, userPermissions } = store.getters;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedOn) {
      return next("/login");
    }
  }

  if (to.matched.some((record) => record.meta.requiresGuest)) {
    if (isLoggedOn) {
      return next("/");
    }
  }

  if (to.matched.some((record) => record.meta.requiresViewPermission)) {
    const moduleName = Object.keys(moduleRouteMapping).find((key) =>
      to.path.startsWith(moduleRouteMapping[key]),
    );

    if (moduleName && !userPermissions[moduleName]?.view) {
      return next("/404");
    }
  }
  if (to.matched.some((record) => record.meta.requiresEditPermission)) {
    const moduleName = Object.keys(moduleRouteMapping).find((key) =>
      to.path.startsWith(moduleRouteMapping[key]),
    );

    if (moduleName && !userPermissions[moduleName]?.edit) {
      return next("/404");
    }
  }

  if (!to.matched.length) {
    return next("/404");
  }

  next();
});

export default router;
